import { json, postBiz } from '../core/coreapi';
import {
  IDeterminantBudgetManager,
  IDeterminantBudgetWorkbench,
} from './determinantBudget.models';

const SERVICE = 'determinantbudget';

/**
 * Planning-Cycle Determinant Budget Manager.
 * DB: budget.spx_determinantbudget_manager(p_planningcycleid, p_userid)
 */
export const fetchDeterminantBudgetManager = async (
  planningcycleid: number,
): Promise<IDeterminantBudgetManager> =>
  json(
    await postBiz({
      s: SERVICE,
      a: 'manager',
      pci: planningcycleid,
    })
  );

/**
 * Record-level Determinant Budget Workbench.
 * DB: budget.spx_determinantbudget_workbench(p_planningcycleid, p_determinantbudgetid, p_userid)
 *
 * `dbi` is the canonical API parameter for determinantbudgetid.
 */
export const fetchDeterminantBudgetWorkbench = async (
  planningcycleid: number,
  determinantbudgetid: number,
): Promise<IDeterminantBudgetWorkbench> =>
  json(
    await postBiz({
      s: SERVICE,
      a: 'workbench',
      pci: planningcycleid,
      dbi: determinantbudgetid,
    })
  );

/**
 * Persist the Determinant Budget management layer.
 *
 * DB contract:
 *   spx_determinantbudget_adjust(
 *     p_determinantbudgetid,
 *     p_adjustmentamount,
 *     p_adjustmentreason,
 *     p_reserveamount,
 *     p_userid
 *   )
 *
 * The economic capacity itself is NOT recomputed here.
 */
export const saveManagementAdjustment = async (p: {
  determinantbudgetid: number;
  adjustmentamount: number;
  adjustmentreason: string;
  reserveamount: number;
}) =>
  json(
    await postBiz({
      s: SERVICE,
      a: 'adjust',
      dbi: p.determinantbudgetid,
      amt: Number(p.adjustmentamount || 0),
      rsn: p.adjustmentreason || '',
      rsv: Number(p.reserveamount || 0),
    })
  );

export const validateDeterminantBudget = async (
  determinantbudgetid: number,
) =>
  json(
    await postBiz({
      s: SERVICE,
      a: 'validate',
      dbi: determinantbudgetid,
    })
  );

export const acceptDeterminantBudget = async (
  determinantbudgetid: number,
  notes = '',
) =>
  json(
    await postBiz({
      s: SERVICE,
      a: 'accept',
      dbi: determinantbudgetid,
      nts: notes,
    })
  );

export const returnDeterminantBudget = async (
  determinantbudgetid: number,
  reason: string,
) =>
  json(
    await postBiz({
      s: SERVICE,
      a: 'return',
      dbi: determinantbudgetid,
      rsn: reason,
    })
  );

export const releaseDeterminantBudget = async (
  determinantbudgetid: number,
  notes = '',
) =>
  json(
    await postBiz({
      s: SERVICE,
      a: 'release',
      dbi: determinantbudgetid,
      nts: notes,
    })
  );
